import { useMsal } from '@azure/msal-react'
import { useRole } from '../contexts/RoleContext'

export default function UnauthorizedPage() {
  const { instance } = useMsal()
  const { userEmail, userDisplayName, error } = useRole()

  const handleLogout = () => {
    instance.logoutRedirect()
  }

  const handleTryDifferentAccount = () => {
    // Clear the current session and redirect to login
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    })
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
          <svg
            className="h-8 w-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>

        <p className="text-gray-600 mb-6">
          You don't have permission to access this application. Your account must be a member of an authorized security group.
        </p>

        {userEmail && (
          <div className="bg-gray-50 rounded-md p-4 mb-6 text-left">
            <p className="text-sm text-gray-500 mb-1">Signed in as:</p>
            <p className="text-sm font-medium text-gray-900">{userDisplayName || userEmail}</p>
            <p className="text-sm text-gray-600">{userEmail}</p>
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-md p-3 mb-6 text-left">
            <p className="text-sm text-red-700">{error}</p>
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={handleTryDifferentAccount}
            className="w-full bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700 transition-colors"
          >
            Try a different account
          </button>

          <button
            onClick={handleLogout}
            className="w-full bg-white text-gray-700 px-4 py-2 rounded-md text-sm font-medium border border-gray-300 hover:bg-gray-50 transition-colors"
          >
            Sign out
          </button>
        </div>

        <p className="mt-6 text-xs text-gray-500">
          If you believe you should have access, please contact your administrator to be added to the appropriate security group.
        </p>
      </div>
    </div>
  )
}
